import type {
  ConfigValue,
  MultilingualConfigValue,
  MultilingualizableConfigValue,
  MultilingualProperties,
} from "../../schemas/index.ts";
import { isMultilingualProperty } from "./filterFunctions.ts";

const MULTILINGUAL_ARRAY_ERROR = `Multilingual properties cannot be arrays.`;

export const enableMultilingualOnProperty = (property: ConfigValue, primaryLang: string): MultilingualProperties => {
  if (Array.isArray(property)) {
    throw new Error(MULTILINGUAL_ARRAY_ERROR);
  }
  return {
    __ml: { [primaryLang]: property },
  };
};

export const enableMultilingualOnPropertyForLanguage = (
  property: ConfigValue | MultilingualConfigValue,
  lang: string,
  initialValue: MultilingualizableConfigValue,
  { primaryLang }: { primaryLang: string },
): MultilingualProperties => {
  const value = isMultilingualProperty(property) ? property : enableMultilingualOnProperty(property, primaryLang);
  if (Array.isArray(initialValue) || Object.values(value.__ml).some(Array.isArray)) {
    throw new Error(MULTILINGUAL_ARRAY_ERROR);
  }
  return {
    __ml: {
      ...value.__ml,
      [lang]: initialValue,
    },
  };
};
